import { useMemo } from 'react'

import {
  type DateRange,
  type FilterByDateRangeOptions,
  filterByDateRange,
} from '@/lib/utils/filterByDateRange'

export function useDateFilter<T extends Record<string, any>>(
  data: T[],
  dateRange: DateRange,
  options: FilterByDateRangeOptions = {},
): T[] {
  return useMemo(() => {
    return filterByDateRange(data, dateRange, options)
  }, [data, dateRange, options])
}
